export const WIDTH_ICON = 24;
export const WIDTH_ADDRESS = 170;
